// @generated by protoc-gen-es v2.16.0 with parameter "target=ts,json_types=true"
// @generated from file forms/v1/field.proto (package forms.v1, syntax proto3)
/* eslint-disable */

import type { GenEnum, GenFile, GenMessage } from "@bufbuild/protobuf/codegenv2";
import { enumDesc, fileDesc, messageDesc } from "@bufbuild/protobuf/codegenv2";
import type { StructJson } from "@bufbuild/protobuf/wkt";
import { file_google_protobuf_struct } from "@bufbuild/protobuf/wkt";
import type { JsonObject, Message } from "@bufbuild/protobuf";

/**
 * Describes the file forms/v1/field.proto.
 */
export const file_forms_v1_field: GenFile =
	/*@__PURE__*/
	fileDesc(
		"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",
		[file_google_protobuf_struct],
	);

/**
 * @generated from message forms.v1.Choice
 */
export type Choice = Message<"forms.v1.Choice"> & {
	/**
	 * @generated from field: string value = 1;
	 */
	value: string;
};

/**
 * @generated from message forms.v1.Choice
 */
export type ChoiceJson = {
	/**
	 * @generated from field: string value = 1;
	 */
	value?: string;
};

/**
 * Describes the message forms.v1.Choice.
 * Use `create(ChoiceSchema)` to create a new message.
 */
export const ChoiceSchema: GenMessage<Choice, { jsonType: ChoiceJson }> = /*@__PURE__*/ messageDesc(file_forms_v1_field, 0);

/**
 * @generated from message forms.v1.ChoiceFieldProperties
 */
export type ChoiceFieldProperties = Message<"forms.v1.ChoiceFieldProperties"> & {
	/**
	 * @generated from field: repeated forms.v1.Choice choices = 1;
	 */
	choices: Choice[];

	/**
	 * @generated from field: forms.v1.ChoiceType choice_type = 2;
	 */
	choiceType: ChoiceType;

	/**
	 * @generated from field: bool allow_other = 3;
	 */
	allowOther: boolean;

	/**
	 * @generated from field: bool searchable = 4;
	 */
	searchable: boolean;
};

/**
 * @generated from message forms.v1.ChoiceFieldProperties
 */
export type ChoiceFieldPropertiesJson = {
	/**
	 * @generated from field: repeated forms.v1.Choice choices = 1;
	 */
	choices?: ChoiceJson[];

	/**
	 * @generated from field: forms.v1.ChoiceType choice_type = 2;
	 */
	choiceType?: ChoiceTypeJson;

	/**
	 * @generated from field: bool allow_other = 3;
	 */
	allowOther?: boolean;

	/**
	 * @generated from field: bool searchable = 4;
	 */
	searchable?: boolean;
};

/**
 * Describes the message forms.v1.ChoiceFieldProperties.
 * Use `create(ChoiceFieldPropertiesSchema)` to create a new message.
 */
export const ChoiceFieldPropertiesSchema: GenMessage<ChoiceFieldProperties, { jsonType: ChoiceFieldPropertiesJson }> = /*@__PURE__*/ messageDesc(file_forms_v1_field, 1);

/**
 * @generated from message forms.v1.TextFieldProperties
 */
export type TextFieldProperties = Message<"forms.v1.TextFieldProperties"> & {
	/**
	 * @generated from field: bool paragraph = 1;
	 */
	paragraph: boolean;
};

/**
 * @generated from message forms.v1.TextFieldProperties
 */
export type TextFieldPropertiesJson = {
	/**
	 * @generated from field: bool paragraph = 1;
	 */
	paragraph?: boolean;
};

/**
 * Describes the message forms.v1.TextFieldProperties.
 * Use `create(TextFieldPropertiesSchema)` to create a new message.
 */
export const TextFieldPropertiesSchema: GenMessage<TextFieldProperties, { jsonType: TextFieldPropertiesJson }> = /*@__PURE__*/ messageDesc(file_forms_v1_field, 2);

/**
 * @generated from message forms.v1.ImageBlockProperties
 */
export type ImageBlockProperties = Message<"forms.v1.ImageBlockProperties"> & {
	/**
	 * @generated from field: string image_url = 1;
	 */
	imageUrl: string;
};

/**
 * @generated from message forms.v1.ImageBlockProperties
 */
export type ImageBlockPropertiesJson = {
	/**
	 * @generated from field: string image_url = 1;
	 */
	imageUrl?: string;
};

/**
 * Describes the message forms.v1.ImageBlockProperties.
 * Use `create(ImageBlockPropertiesSchema)` to create a new message.
 */
export const ImageBlockPropertiesSchema: GenMessage<ImageBlockProperties, { jsonType: ImageBlockPropertiesJson }> = /*@__PURE__*/ messageDesc(file_forms_v1_field, 3);

/**
 * @generated from message forms.v1.LegalFieldProperties
 */
export type LegalFieldProperties = Message<"forms.v1.LegalFieldProperties"> & {
	/**
	 * @generated from field: string terms_link = 1;
	 */
	termsLink: string;

	/**
	 * @generated from field: string disclaimer = 2;
	 */
	disclaimer: string;

	/**
	 * @generated from field: forms.v1.PolicyRef policy_ref = 3;
	 */
	policyRef?: PolicyRef | undefined;
};

/**
 * @generated from message forms.v1.LegalFieldProperties
 */
export type LegalFieldPropertiesJson = {
	/**
	 * @generated from field: string terms_link = 1;
	 */
	termsLink?: string;

	/**
	 * @generated from field: string disclaimer = 2;
	 */
	disclaimer?: string;

	/**
	 * @generated from field: forms.v1.PolicyRef policy_ref = 3;
	 */
	policyRef?: PolicyRefJson;
};

/**
 * Describes the message forms.v1.LegalFieldProperties.
 * Use `create(LegalFieldPropertiesSchema)` to create a new message.
 */
export const LegalFieldPropertiesSchema: GenMessage<LegalFieldProperties, { jsonType: LegalFieldPropertiesJson }> = /*@__PURE__*/ messageDesc(file_forms_v1_field, 4);

/**
 * @generated from message forms.v1.DateProperties
 */
export type DateProperties = Message<"forms.v1.DateProperties"> & {
	/**
	 * @generated from field: forms.v1.InputType input_type = 1;
	 */
	inputType: InputType;
};

/**
 * @generated from message forms.v1.DateProperties
 */
export type DatePropertiesJson = {
	/**
	 * @generated from field: forms.v1.InputType input_type = 1;
	 */
	inputType?: InputTypeJson;
};

/**
 * Describes the message forms.v1.DateProperties.
 * Use `create(DatePropertiesSchema)` to create a new message.
 */
export const DatePropertiesSchema: GenMessage<DateProperties, { jsonType: DatePropertiesJson }> = /*@__PURE__*/ messageDesc(file_forms_v1_field, 5);

/**
 * @generated from message forms.v1.FileUploadProperties
 */
export type FileUploadProperties = Message<"forms.v1.FileUploadProperties"> & {
	/**
	 * @generated from field: bool capture_image = 1;
	 */
	captureImage: boolean;
};

/**
 * @generated from message forms.v1.FileUploadProperties
 */
export type FileUploadPropertiesJson = {
	/**
	 * @generated from field: bool capture_image = 1;
	 */
	captureImage?: boolean;
};

/**
 * Describes the message forms.v1.FileUploadProperties.
 * Use `create(FileUploadPropertiesSchema)` to create a new message.
 */
export const FileUploadPropertiesSchema: GenMessage<FileUploadProperties, { jsonType: FileUploadPropertiesJson }> = /*@__PURE__*/ messageDesc(file_forms_v1_field, 6);

/**
 * @generated from message forms.v1.PolicyRef
 */
export type PolicyRef = Message<"forms.v1.PolicyRef"> & {
	/**
	 * @generated from field: string id = 1;
	 */
	id: string;

	/**
	 * @generated from field: string version = 2;
	 */
	version: string;
};

/**
 * @generated from message forms.v1.PolicyRef
 */
export type PolicyRefJson = {
	/**
	 * @generated from field: string id = 1;
	 */
	id?: string;

	/**
	 * @generated from field: string version = 2;
	 */
	version?: string;
};

/**
 * Describes the message forms.v1.PolicyRef.
 * Use `create(PolicyRefSchema)` to create a new message.
 */
export const PolicyRefSchema: GenMessage<PolicyRef, { jsonType: PolicyRefJson }> = /*@__PURE__*/ messageDesc(file_forms_v1_field, 7);

/**
 * @generated from message forms.v1.FieldProperties
 */
export type FieldProperties = Message<"forms.v1.FieldProperties"> & {
	/**
	 * @generated from oneof forms.v1.FieldProperties.properties
	 */
	properties:
		| {
				/**
				 * @generated from field: forms.v1.ChoiceFieldProperties choice = 1;
				 */
				value: ChoiceFieldProperties;
				case: "choice";
		  }
		| {
				/**
				 * @generated from field: forms.v1.TextFieldProperties text_field = 2;
				 */
				value: TextFieldProperties;
				case: "textField";
		  }
		| {
				/**
				 * @generated from field: forms.v1.ImageBlockProperties image = 3;
				 */
				value: ImageBlockProperties;
				case: "image";
		  }
		| {
				/**
				 * @generated from field: forms.v1.LegalFieldProperties legal = 4;
				 */
				value: LegalFieldProperties;
				case: "legal";
		  }
		| {
				/**
				 * @generated from field: forms.v1.DateProperties date = 5;
				 */
				value: DateProperties;
				case: "date";
		  }
		| {
				/**
				 * @generated from field: forms.v1.FileUploadProperties file_upload = 6;
				 */
				value: FileUploadProperties;
				case: "fileUpload";
		  }
		| { case: undefined; value?: undefined };
};

/**
 * @generated from message forms.v1.FieldProperties
 */
export type FieldPropertiesJson = {
	/**
	 * @generated from field: forms.v1.ChoiceFieldProperties choice = 1;
	 */
	choice?: ChoiceFieldPropertiesJson;

	/**
	 * @generated from field: forms.v1.TextFieldProperties text_field = 2;
	 */
	textField?: TextFieldPropertiesJson;

	/**
	 * @generated from field: forms.v1.ImageBlockProperties image = 3;
	 */
	image?: ImageBlockPropertiesJson;

	/**
	 * @generated from field: forms.v1.LegalFieldProperties legal = 4;
	 */
	legal?: LegalFieldPropertiesJson;

	/**
	 * @generated from field: forms.v1.DateProperties date = 5;
	 */
	date?: DatePropertiesJson;

	/**
	 * @generated from field: forms.v1.FileUploadProperties file_upload = 6;
	 */
	fileUpload?: FileUploadPropertiesJson;
};

/**
 * Describes the message forms.v1.FieldProperties.
 * Use `create(FieldPropertiesSchema)` to create a new message.
 */
export const FieldPropertiesSchema: GenMessage<FieldProperties, { jsonType: FieldPropertiesJson }> = /*@__PURE__*/ messageDesc(file_forms_v1_field, 8);

/**
 * Represents a model.field to which a form
 * field can be bound
 *
 * @generated from message forms.v1.ModelField
 */
export type ModelField = Message<"forms.v1.ModelField"> & {
	/**
	 * the model key (e.g. contact)
	 *
	 * @generated from field: string model_key = 1;
	 */
	modelKey: string;

	/**
	 * optional model version
	 *
	 * @generated from field: string model_version = 2;
	 */
	modelVersion: string;

	/**
	 * the key for the model field (e.g. first_name)
	 *
	 * @generated from field: string model_field_key = 3;
	 */
	modelFieldKey: string;

	/**
	 * optional model field version
	 *
	 * @generated from field: string model_field_version = 4;
	 */
	modelFieldVersion: string;
};

/**
 * Represents a model.field to which a form
 * field can be bound
 *
 * @generated from message forms.v1.ModelField
 */
export type ModelFieldJson = {
	/**
	 * the model key (e.g. contact)
	 *
	 * @generated from field: string model_key = 1;
	 */
	modelKey?: string;

	/**
	 * optional model version
	 *
	 * @generated from field: string model_version = 2;
	 */
	modelVersion?: string;

	/**
	 * the key for the model field (e.g. first_name)
	 *
	 * @generated from field: string model_field_key = 3;
	 */
	modelFieldKey?: string;

	/**
	 * optional model field version
	 *
	 * @generated from field: string model_field_version = 4;
	 */
	modelFieldVersion?: string;
};

/**
 * Describes the message forms.v1.ModelField.
 * Use `create(ModelFieldSchema)` to create a new message.
 */
export const ModelFieldSchema: GenMessage<ModelField, { jsonType: ModelFieldJson }> = /*@__PURE__*/ messageDesc(file_forms_v1_field, 9);

/**
 * @generated from message forms.v1.Field
 */
export type Field = Message<"forms.v1.Field"> & {
	/**
	 * @generated from field: string id = 1;
	 */
	id: string;

	/**
	 * @generated from field: string name = 2;
	 */
	name: string;

	/**
	 * @generated from field: string title = 3;
	 */
	title: string;

	/**
	 * @generated from field: string description = 4;
	 */
	description: string;

	/**
	 * @generated from field: bool active = 5;
	 */
	active: boolean;

	/**
	 * @generated from field: forms.v1.FieldType field_type = 6;
	 */
	fieldType: FieldType;

	/**
	 * @generated from field: bool required = 7;
	 */
	required: boolean;

	/**
	 * @generated from field: forms.v1.FieldProperties properties = 8;
	 */
	properties?: FieldProperties | undefined;

	/**
	 * whether the field is editable in the editor
	 *
	 * @generated from field: bool immutable = 9;
	 */
	immutable: boolean;

	/**
	 * whether the field is fillable on a landing page
	 *
	 * @generated from field: bool static = 10;
	 */
	static: boolean;

	/**
	 * @generated from field: google.protobuf.Struct default_value = 11;
	 */
	defaultValue?: JsonObject | undefined;

	/**
	 * the model field bound to this form field
	 *
	 * @generated from field: forms.v1.ModelField model_field_binding = 12;
	 */
	modelFieldBinding?: ModelField | undefined;

	/**
	 * @generated from field: string validation_schema = 13;
	 */
	validationSchema: string;
};

/**
 * @generated from message forms.v1.Field
 */
export type FieldJson = {
	/**
	 * @generated from field: string id = 1;
	 */
	id?: string;

	/**
	 * @generated from field: string name = 2;
	 */
	name?: string;

	/**
	 * @generated from field: string title = 3;
	 */
	title?: string;

	/**
	 * @generated from field: string description = 4;
	 */
	description?: string;

	/**
	 * @generated from field: bool active = 5;
	 */
	active?: boolean;

	/**
	 * @generated from field: forms.v1.FieldType field_type = 6;
	 */
	fieldType?: FieldTypeJson;

	/**
	 * @generated from field: bool required = 7;
	 */
	required?: boolean;

	/**
	 * @generated from field: forms.v1.FieldProperties properties = 8;
	 */
	properties?: FieldPropertiesJson;

	/**
	 * whether the field is editable in the editor
	 *
	 * @generated from field: bool immutable = 9;
	 */
	immutable?: boolean;

	/**
	 * whether the field is fillable on a landing page
	 *
	 * @generated from field: bool static = 10;
	 */
	static?: boolean;

	/**
	 * @generated from field: google.protobuf.Struct default_value = 11;
	 */
	defaultValue?: StructJson;

	/**
	 * the model field bound to this form field
	 *
	 * @generated from field: forms.v1.ModelField model_field_binding = 12;
	 */
	modelFieldBinding?: ModelFieldJson;

	/**
	 * @generated from field: string validation_schema = 13;
	 */
	validationSchema?: string;
};

/**
 * Describes the message forms.v1.Field.
 * Use `create(FieldSchema)` to create a new message.
 */
export const FieldSchema: GenMessage<Field, { jsonType: FieldJson }> = /*@__PURE__*/ messageDesc(file_forms_v1_field, 10);

/**
 * @generated from enum forms.v1.FieldType
 */
export enum FieldType {
	/**
	 * @generated from enum value: FIELD_TYPE_UNSPECIFIED = 0;
	 */
	UNSPECIFIED = 0,

	/**
	 * @generated from enum value: FIELD_TYPE_TEXT = 1;
	 */
	TEXT = 1,

	/**
	 * @generated from enum value: FIELD_TYPE_ADDRESS = 2;
	 */
	ADDRESS = 2,

	/**
	 * @generated from enum value: FIELD_TYPE_CHOICE = 3;
	 */
	CHOICE = 3,

	/**
	 * @generated from enum value: FIELD_TYPE_EMAIL = 4;
	 */
	EMAIL = 4,

	/**
	 * @generated from enum value: FIELD_TYPE_PHONE = 5;
	 */
	PHONE = 5,

	/**
	 * @generated from enum value: FIELD_TYPE_LEGAL = 6;
	 */
	LEGAL = 6,

	/**
	 * @generated from enum value: FIELD_TYPE_DATE = 7;
	 */
	DATE = 7,

	/**
	 * @generated from enum value: FIELD_TYPE_BLOCK_TEXT = 8;
	 */
	BLOCK_TEXT = 8,

	/**
	 * @generated from enum value: FIELD_TYPE_NAME = 9;
	 */
	NAME = 9,

	/**
	 * @generated from enum value: FIELD_TYPE_BLOCK_IMAGE = 10;
	 */
	BLOCK_IMAGE = 10,

	/**
	 * @generated from enum value: FIELD_TYPE_POLL = 11;
	 */
	POLL = 11,

	/**
	 * @generated from enum value: FIELD_TYPE_FILE_UPLOAD = 12;
	 */
	FILE_UPLOAD = 12,

	/**
	 * @generated from enum value: FIELD_TYPE_NUMBER = 13;
	 */
	NUMBER = 13,
}

/**
 * @generated from enum forms.v1.FieldType
 */
export type FieldTypeJson = "FIELD_TYPE_UNSPECIFIED" | "FIELD_TYPE_TEXT" | "FIELD_TYPE_ADDRESS" | "FIELD_TYPE_CHOICE" | "FIELD_TYPE_EMAIL" | "FIELD_TYPE_PHONE" | "FIELD_TYPE_LEGAL" | "FIELD_TYPE_DATE" | "FIELD_TYPE_BLOCK_TEXT" | "FIELD_TYPE_NAME" | "FIELD_TYPE_BLOCK_IMAGE" | "FIELD_TYPE_POLL" | "FIELD_TYPE_FILE_UPLOAD" | "FIELD_TYPE_NUMBER";

/**
 * Describes the enum forms.v1.FieldType.
 */
export const FieldTypeSchema: GenEnum<FieldType, FieldTypeJson> = /*@__PURE__*/ enumDesc(file_forms_v1_field, 0);

/**
 * @generated from enum forms.v1.ChoiceType
 */
export enum ChoiceType {
	/**
	 * @generated from enum value: CHOICE_TYPE_UNSPECIFIED = 0;
	 */
	UNSPECIFIED = 0,

	/**
	 * @generated from enum value: CHOICE_TYPE_RADIO = 1;
	 */
	RADIO = 1,

	/**
	 * @generated from enum value: CHOICE_TYPE_DROPDOWN = 2;
	 */
	DROPDOWN = 2,

	/**
	 * @generated from enum value: CHOICE_TYPE_CHECKBOX = 3;
	 */
	CHECKBOX = 3,

	/**
	 * @generated from enum value: CHOICE_TYPE_BOOL = 4;
	 */
	BOOL = 4,
}

/**
 * @generated from enum forms.v1.ChoiceType
 */
export type ChoiceTypeJson = "CHOICE_TYPE_UNSPECIFIED" | "CHOICE_TYPE_RADIO" | "CHOICE_TYPE_DROPDOWN" | "CHOICE_TYPE_CHECKBOX" | "CHOICE_TYPE_BOOL";

/**
 * Describes the enum forms.v1.ChoiceType.
 */
export const ChoiceTypeSchema: GenEnum<ChoiceType, ChoiceTypeJson> = /*@__PURE__*/ enumDesc(file_forms_v1_field, 1);

/**
 * @generated from enum forms.v1.InputType
 */
export enum InputType {
	/**
	 * @generated from enum value: INPUT_TYPE_UNSPECIFIED = 0;
	 */
	UNSPECIFIED = 0,

	/**
	 * @generated from enum value: INPUT_TYPE_SINGLE = 1;
	 */
	SINGLE = 1,

	/**
	 * @generated from enum value: INPUT_TYPE_MULTIPLE = 2;
	 */
	MULTIPLE = 2,
}

/**
 * @generated from enum forms.v1.InputType
 */
export type InputTypeJson = "INPUT_TYPE_UNSPECIFIED" | "INPUT_TYPE_SINGLE" | "INPUT_TYPE_MULTIPLE";

/**
 * Describes the enum forms.v1.InputType.
 */
export const InputTypeSchema: GenEnum<InputType, InputTypeJson> = /*@__PURE__*/ enumDesc(file_forms_v1_field, 2);
